module.exports = __webpack_public_path__ + "static/media/memories_17.0e15aca3.jpg";